import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment'; 
import { baseUrl } from "../../utils/constants";


class CalendarAdd extends Component {
  // "2022-09-27T23:30:51.000Z"
  // "2022-09-28T23:30:51.000Z"
	constructor(props) {
    super(props);
			this.state = { 
        startDate: this.props.item.dueDate?moment(this.props.item.dueDate).format('YYYY-MM-DD'):'',
        // startTime: this.props.item.dueDate?moment(this.props.item.dueDate).format('HH:mm:ss'):'',
        startTime: '',
        endDate: this.props.item.endDate? moment(this.props.item.endDate).format('YYYY-MM-DD'):
                  this.props.item.dueDate?moment(this.props.item.dueDate).format('YYYY-MM-DD'):'',
        // endTime: this.props.item.dueDate? moment(this.props.item.endDate).format('HH:mm:ss'):'',
        endTime: '',
        itemURL : '',
        description:this.props.description?this.props.description + '<br/>':''
		  }

    }


componentDidMount(){   
  const hostname = window.location.hostname;
  let itemUrl = `${baseUrl(hostname)}/home/planning/${this.props.item._id}?o=${this.props.item.organizationId}`
  this.setState({itemUrl})
}


                

	render() {
    let{startDate,startTime,endDate,endTime,description,itemUrl}=this.state, result={}

    if(startTime!=""){
      result.startTime=startTime
    }
    if(endDate!=""){
      result.endDate=endDate
    }
    if(endTime!=""){
      result.endTime=endTime
    }

    description = description + '<br/>' + '<p>link to task:</p>' + '<br/>' +`<a href=${itemUrl} target="_blank">${itemUrl}</a>`

        return (<span className="planning_details_add_to_cal_icon"> 
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    window.atcb_action({
                      name:this.props.item.title,
                      description,
                      startDate,
                      ...result,
                      timeZone:'currentBrowser',
                      options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Yahoo'],
                      label:'Add to Calendar',
                      iCalFileName: this.props.item.title.replace(/\s/g, ""),
                    });
                  }}>
                     <button className="planning_details_add_to_cal_btn_sub" type="submit">
                        <svg xmlns="http://www.w3.org/2000/svg" 
                        // fill="white"
                        // fill="#be0000cc"
                        viewBox="0 0 200 200.016">
                          <path d="M132.829 7.699c0-4.248 4.199-7.699 9.391-7.699s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zm-5.941 123.747c2.979 0 5.404 2.425 5.404 5.404s-2.425 5.404-5.404 5.404l-21.077-.065-.065 21.045c0 2.979-2.425 5.404-5.404 5.404s-5.404-2.425-5.404-5.404l.065-21.061-21.045-.081c-2.979 0-5.404-2.425-5.404-5.404s2.425-5.404 5.404-5.404l21.061.065.065-21.045c0-2.979 2.425-5.404 5.404-5.404s5.404 2.425 5.404 5.404l-.065 21.077 21.061.065zM48.193 7.699C48.193 3.451 52.393 0 57.585 0s9.391 3.451 9.391 7.699v33.724c0 4.248-4.199 7.699-9.391 7.699s-9.391-3.451-9.391-7.699zM10.417 73.763h179.167V34.945c0-1.302-.537-2.49-1.4-3.369-.863-.863-2.051-1.4-3.369-1.4h-17.171c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h17.171c4.183 0 7.975 1.709 10.726 4.46S200 30.762 200 34.945v44.043 105.843c0 4.183-1.709 7.975-4.46 10.726s-6.543 4.46-10.726 4.46H15.186c-4.183 0-7.975-1.709-10.726-4.46C1.709 192.79 0 188.997 0 184.814V78.988 34.945c0-4.183 1.709-7.975 4.46-10.726s6.543-4.46 10.726-4.46h18.343c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208H15.186c-1.302 0-2.49.537-3.369 1.4-.863.863-1.4 2.051-1.4 3.369zm179.167 10.433H10.417v100.618c0 1.302.537 2.49 1.4 3.369.863.863 2.051 1.4 3.369 1.4h169.629c1.302 0 2.49-.537 3.369-1.4.863-.863 1.4-2.051 1.4-3.369zM82.08 30.176c-2.881 0-5.208-2.327-5.208-5.208s2.327-5.208 5.208-5.208h34.977c2.881 0 5.208 2.327 5.208 5.208s-2.327 5.208-5.208 5.208z">
                        </path></svg>
                        Add to Calendar
                      </button>
                  {/* <input type="submit"/> */}
                </form>
             </span>)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CalendarAdd));


  
  